import { useState } from 'react';
import DriverRow from './DriverRow.jsx';

/**
 * ResultsAccordion — controlled list of expandable result rows.
 *
 * One row at a time can be expanded. This is a single-select accordion
 * because the result detail block adds ~80 px of height; allowing
 * multi-select makes the list jump around as the user scrolls.
 *
 * Header is sticky-ish (no `position: sticky` to keep behaviour predictable
 * inside the parent scroll context) — sits above the list as a column key.
 */
export default function ResultsAccordion({ results }) {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="mt-5">
      <div className="mb-2 flex items-center gap-2 px-1">
        <h3 className="text-sm font-semibold text-ink-primary">Full Classification</h3>
        <span className="ml-auto text-2xs uppercase tracking-widest-plus text-ink-tertiary">
          {results.length} drivers
        </span>
      </div>

      <div className="mb-2 grid grid-cols-[36px_1fr_auto_24px] gap-2 px-3 text-[10px] font-bold uppercase tracking-widest-plus text-ink-tertiary">
        <span>Pos</span>
        <span>Driver / Team</span>
        <span className="text-right">Gap / Pts</span>
        <span />
      </div>

      <div className="space-y-2">
        {results.map((result) => (
          <DriverRow
            key={result.driver_number}
            result={result}
            expanded={expandedId === result.driver_number}
            onToggle={() =>
              setExpandedId((curr) => (curr === result.driver_number ? null : result.driver_number))
            }
          />
        ))}
      </div>
    </div>
  );
}
